function orgUserTagPrefix({ orgId, key }) {
    return `${orgId}:${key}:`
}

export function hasOrgUserTagValue({ orgId, userTags, key }) {
    if (!orgId || !key || !Array.isArray(userTags)) return false

    const prefix = orgUserTagPrefix({ orgId, key })
    return userTags.some(tag => typeof tag === 'string' && tag.startsWith(prefix) && tag.length > prefix.length)
}

export function missingRequiredOrgUserTagQuestions({ orgId, userTags, formConfig }) {
    return (formConfig?.questions || []).filter(question =>
        question.required &&
        !hasOrgUserTagValue({ orgId, userTags, key: question.value }),
    )
}

export function userTagFormConfigWithExistingAnswersReadOnly({ orgId, userTags, formConfig }) {
    if (!formConfig) return null

    return {
        ...formConfig,
        questions: (formConfig.questions || []).map(question => ({
            ...question,
            readOnly: question.readOnly || hasOrgUserTagValue({
                orgId,
                userTags,
                key: question.value,
            }),
        })),
    }
}
